export class GTM {
    static trackEvent(event) {
        window.dataLayer.push(event);
    }
}
